import lottie from "lottie-web";

/* eslint-disable */
function animateLogo() {
  function preloaderAnimation() {
    const lottieUrl = themeVars.animate_logo;

    const anim = lottie.loadAnimation({
      container: document.getElementById("lottie-preloader"),
      renderer: "svg",
      loop: false,
      autoplay: true,
      path: lottieUrl,
    });

    setTimeout(() => {
      document.getElementById("lottie-preloader")?.parentElement?.classList.add("hide");
    }, 2000);

    document.querySelectorAll(".lottie-once").forEach((el) => {
      let initialDrawn = false;
      let isPlaying = false;

      const anim = lottie.loadAnimation({
        container: el,
        renderer: "svg",
        loop: false,
        autoplay: false,
        path: themeVars.animate_logo,
        rendererSettings: { preserveAspectRatio: "xMidYMid meet" },
      });

      function resolveFrame(expr) {
        const total = Math.floor(anim.totalFrames || anim.getDuration(true) || 1);
        const fr = anim?.animationData?.fr || 60;
        if (!expr || expr === "first") return 0;
        if (expr === "last") return Math.max(0, total - 1);
        const m1 = /^frame:(\d+)$/i.exec(expr);
        if (m1) return Math.min(Math.max(0, parseInt(m1[1], 10)), total - 1);
        const m2 = /^marker:(.+)$/i.exec(expr);
        if (m2 && anim.animationData?.markers?.length) {
          const mk = anim.animationData.markers.find((x) => x.cm === m2[1].trim());
          if (mk && typeof mk.tm === "number") {
            const f = Math.floor(mk.tm * fr);
            return Math.min(Math.max(0, f), total - 1);
          }
        }
        return 0;
      }

      function drawInitial() {
        if (initialDrawn) return;
        if (!anim.animationData || !anim.totalFrames) return;
        const initExpr = el.dataset.init || el.dataset.final || "last";
        const frame = resolveFrame(initExpr);
        requestAnimationFrame(() => {
          anim.goToAndStop(frame, true);
          anim.resize();
          requestAnimationFrame(() => {
            anim.goToAndStop(frame, true);
            initialDrawn = true;
          });
        });
      }

      anim.addEventListener("data_ready", drawInitial);
      anim.addEventListener("DOMLoaded", drawInitial);
      anim.addEventListener("loaded_images", drawInitial);
      if (anim.animationData && anim.totalFrames) drawInitial();
      setTimeout(drawInitial, 250);

      const io = new IntersectionObserver((entries) => {
        entries.forEach((en) => { if (en.isIntersecting) drawInitial(); });
      }, { threshold: 0.01 });
      io.observe(el);

      const ro = new ResizeObserver(() => drawInitial());
      ro.observe(el);

      function playFromStartToFinal() {
        if (isPlaying) return;
        isPlaying = true;
        const total = Math.floor(anim.totalFrames || anim.getDuration(true) || 1);
        const finalExpr = el.dataset.final || "last";
        const end = Math.min(resolveFrame(finalExpr), total - 1);
        const onComplete = () => {
          anim.goToAndStop(end, true);
          isPlaying = false;
          anim.removeEventListener("complete", onComplete);
        };
        anim.removeEventListener("complete", onComplete);
        anim.goToAndStop(0, true);
        anim.playSegments([0, end], true);
        anim.addEventListener("complete", onComplete);
      }

      el.addEventListener("mouseenter", playFromStartToFinal);
      el.addEventListener("touchstart", () => playFromStartToFinal(), { passive: true });

      el.setAttribute("tabindex", "0");
      el.addEventListener("keydown", (e) => {
        if ((e.key === "Enter" || e.key === " ") && !isPlaying) {
          e.preventDefault();
          playFromStartToFinal();
        }
      });

      // === Remove SVG masks and clip-paths after Lottie DOM is ready ===
      function stripMasksAndClips() {
        const svg = el.querySelector("svg");
        if (!svg) return;

        const selectors = [
          "g > g:nth-of-type(3) > g",
          "g > g:nth-of-type(7) > g:nth-of-type(1)",
        ];

        selectors.forEach((selector) => {
          const group = svg.querySelector(selector);
          if (!group) return;

          group.querySelectorAll("[mask]").forEach((el) => el.removeAttribute("mask"));
          group.querySelectorAll("mask").forEach((el) => el.remove());
        });
      }


      // Run once DOM is ready
      anim.addEventListener("DOMLoaded", stripMasksAndClips);
      anim.addEventListener("data_ready", stripMasksAndClips);
      anim.addEventListener("complete", stripMasksAndClips);

      // As a fallback, recheck a few times in case animation replaces DOM
      setTimeout(stripMasksAndClips, 500);
      setTimeout(stripMasksAndClips, 1500);
    });

  }

  preloaderAnimation();
}

export { animateLogo };

